import axios from '../api/index.js';

//查询合作伙伴列表
export let getPartnerQuery = () => {
    return axios.post(`/client/cooperative/partner/list`);
};



// WEBPACK FOOTER //
// ./src/api/partner.js